import { setSelectedOtherExtras } from '../actions';

export default function setSelectedOtherExtrasInitialValue() {
  return (dispatch, getState) => {
    const { checkoutPagePackagesSearch } = getState();
    const { cancellationProtectionRefs } = checkoutPagePackagesSearch.value.packages[0];
    let cancellationProtection = null;

    if (cancellationProtectionRefs && cancellationProtectionRefs.length > 0) {
      cancellationProtection = cancellationProtectionRefs[0];
    }

    dispatch(
      setSelectedOtherExtras({
        transfer: null,
        vehicleRentals: null,
        insurance: null,
        cancellationProtection,
      })
    );
  };
}
